import React, { useState } from "react";
import BgComponent from "../Components/BgComponent";
import Logo from "../../../assets/image/logo/logo.png";
import CustomFormLabel from "../../../components/common/CustomFormLabel";
import RHFTextField from "../../../components/controls/RHFTextField";
import { Link, useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import { useUser } from "../../../context/UserContext";
import { object, ref, string } from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import Supabase from "../../../backend/client";
import { errorToaster, successToaster } from "../../../util/toaster";

const RecoverPassword = () => {
  const user = useUser();
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();

  const schema = object({
    password: string()
      .min(6, "Password must contain atleast 6 characters.")
      .required()
      .label("Password")
      .nullable(),
    conpassword: string()
      .oneOf([ref("password"), null], "Passwords must match")
      .label("Confirm Password")
      .required(),
  });

  const {
    control,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  });

  React.useEffect(() => {
    document.title = "TRADEFOLIO - Update Password";
    const func = async () => {
      const { data, error } = await Supabase.auth.getUser();
      if (!data?.user) {
        navigate("/");
      }
    };
    func();
  }, []);

  const onSubmit = async (val) => {
    const { data, error } = await Supabase.auth.updateUser({
      password: val?.password,
    });

    if (error) {
      errorToaster(error?.message);
      return;
    }
    successToaster("Password changed successfully");
    navigate("/dashboard");
  };

  return (
    <>
      <div className="lg:hidden xs:mb-0">
        <IconButton
          onClick={() => navigate(-1)}
          sx={{
            margin: 3,
            color: "#000",
            position: "absolute",
            zIndex: 999,
          }}>
          <ArrowBackIcon />
        </IconButton>
      </div>
      <div className="flex flex-row w-full h-[100vh]">
        <div className="lg:flex flex-[0.40] xs:hidden">
          <BgComponent bgImg="bg-reset-bg">
            <div className="bg-[#0061fc] mix-blend-multiply absolute w-full h-[100%]"></div>

            <p className="text-white xl:text-[50px] lg:text-[40px] font-bold absolute top-40 xl:left-28 lg:left-16">
              Use Expert Tools <br />
              Without Coding Skills.
            </p>
          </BgComponent>
        </div>
        <div className="flex md:flex-[0.60] xs:flex-[0.80] flex-col lg:max-w-[550px] mx-auto xs:pt-[80px] md:pt-[40px] md:justify-center">
          <a href="/">
            <img src={Logo} className="relative xs:w-[120px] md:w-[170px]" />
          </a>
          <div className="xs:py-4 md:py-12 xl:px-0">
            <p className="xs:text-[22px] md:text-[35px] font-bold font-sans">
              Recover password
            </p>
            <p className="text-[#7A86A1] text-xs md:text-sm">
              Create new password.
            </p>
            <div className="grid grid-cols-1 lg:grid-cols-2 xs:gap-[10px] md:gap-5 xs:pt-[15px] md:pt-10">
              <div>
                <CustomFormLabel htmlFor="password">
                  New Password
                </CustomFormLabel>
                <RHFTextField
                  name="password"
                  id="password"
                  type="password"
                  fullWidth
                  placeholder="******"
                  className="mt-[10px] px-[10px] xs:py-[5px] md:py-[10px] w-full text-[12px] text-[#7A86A1] border-[1px] border-[#7A86A1] rounded-lg "
                  isControlled={true}
                  control={control}
                  errorObj={errors}
                />
              </div>
              <div></div>
              <div>
                <CustomFormLabel htmlFor="conpassword">
                  Confirm Password
                </CustomFormLabel>
                <RHFTextField
                  name="conpassword"
                  id="conpassword"
                  type="password"
                  fullWidth
                  placeholder="******"
                  className="mt-[10px] px-[10px] xs:py-[5px] md:py-[10px] w-full text-[12px] text-[#7A86A1] border-[1px] border-[#7A86A1] rounded-lg "
                  isControlled={true}
                  control={control}
                  errorObj={errors}
                />
              </div>
              <div></div>
              <div>
                <button
                  className="w-full bg-[#0061FC] text-white  font-semibold xs:p-1 md:p-3 rounded-lg xs:text-[12px] md:text-[14px]"
                  onClick={handleSubmit(onSubmit)}>
                  Submit
                </button>
              </div>
              <div></div>
              {/* <div  >
                        <Link to="/auth/login" className='text-[#0061FC]  font-semibold xs:text-[12px] md:text-[14px]'>
                            <KeyboardBackspaceIcon /> Back to sign in
                        </Link>
                        </div> */}
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 flex justify-between py-[20px] md:px-20 xs:px-4  lg:text-[#ffffffCC] xs:text-[#000000] w-full border-t-[1px]">
          <div className="opacity-50 text-[10px] font-sans">
            &copy;2023 TRADEFOLIO Inc. All Rights Reserved
          </div>
          <div className="opacity-50 text-[10px] font-sans  ">
            <Link to="/privacy">
              <u>Privacy Policy</u>
            </Link>{" "}
            /{" "}
            <Link to="/terms">
              <u>User agreement</u>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default RecoverPassword;
